import styled from 'styled-components/macro'
import MainBg from './assets/images/bg_full.svg'

export const MainWrapper = styled.div`
  background-image: url(${MainBg});
  background-color: #f1f2f6;
  min-height: calc(100vh - 160px);
  background-size: cover;
  background-attachment: fixed;
  padding-top: 3rem;
  padding-bottom: 3rem;
`
export const TitleWrapper = styled.div`
  position: relative;
`
export const Title = styled.h1`
  position: relative;
  z-index: 2;
  line-height: 1.5;
  text-align: center;
  font-family: MarketSans, sans-serif;
  font-size: 36px;
  text-transform: uppercase;
  color: #154ba0;

  @media (min-width: 768px) {
    font-size: 40px;
  }
  @media (min-width: 992px) {
    font-size: 45px;
  }
  @media (min-width: 1200px) {
    font-size: 50px;
  }
`
export const TitleShadow = styled.span`
  position: absolute;
  top: 0;
  left: 50%;
  margin-top: 2px;
  margin-left: 2px;
  transform: translate(-50%);
  z-index: 1;
  width: 100%;
  line-height: 1.5;
  text-align: center;
  font-family: MarketSans, sans-serif;
  font-size: 36px;
  text-transform: uppercase;
  color: transparent;
  -webkit-text-stroke-width: 2px;
  -webkit-text-stroke-color: #727eaa;

  @media (min-width: 768px) {
    font-size: 40px;
    margin-top: 3px;
    margin-left: 3px;
  }
  @media (min-width: 992px) {
    font-size: 45px;
  }
  @media (min-width: 1200px) {
    font-size: 50px;
  }
`
